'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const MonthlyBurialsChart = dynamic(() => import('./MonthlyBurialsChart'), { ssr: false });
const RevenueChart = dynamic(() => import('./RevenueChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-6">
      <MonthlyBurialsChart />
      <RevenueChart />
    </div>
  );
}